<span class="link {{modifierBolder}}" (click)="handleRedirect()" [title]="title">    
    <ng-content></ng-content>
</span>


